import { Grid } from '@mui/material';
import { useSnackbar } from 'notistack';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { useCreateListDataMutation } from '../../api/apiSlice';
import FormikButton from '../../components/formik/FormikButton';
import FormikInput from '../../components/formik/FormikInput';
import FormikSelect from '../../components/formik/FormikSelect';
import Screen from '../../components/fragments/Screen';
import Form from '../../components/utilities/Form';
import { educationInputs, genderInputs, optionInputs } from '../../enums';
import errorSnackbar from '../../utils/errorSnackbar';

const validate = Yup.object().shape({
    firstName: Yup.string().required().label('First Name'),
    surname: Yup.string().required().label('Last Name'),
    gender: Yup.string().required().label('Gender'),
    dob: Yup.string().required().label('Date of Birth'),
    education: Yup.string().required().label('Education Level'),
    baptised: Yup.string().required().label('Baptised'),
    confirmed: Yup.string().required().label('Confirmed'),
    disability: Yup.string().required().label('Disability'),
    occupation: Yup.string().required().label('Occupation'),
});

export default function ChildrenAddScreen() {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const [createListData, { isLoading }] = useCreateListDataMutation();

    return (
        <Screen title="Add Child">
            <Grid item xs={12}>
                <Form
                    validationSchema={validate}
                    onSubmit={async (vals) => {
                        const { error, data } = await createListData({
                            list: `user/children`,
                            body: {
                                ...vals,
                                dob: vals.dob?.replaceAll('-', '/'),
                            },
                        });

                        errorSnackbar(error, enqueueSnackbar);

                        if (data) {
                            enqueueSnackbar('Success adding child');
                            navigate(-1);
                        }
                    }}
                    initialValues={{
                        firstName: '',
                        surname: '',
                        gender: '',
                        dob: '',
                        education: '',
                        baptised: '',
                        confirmed: '',
                        disability: '',
                        occupation: '',
                    }}
                >
                    <FormikInput name="firstName" label="First Name" />
                    <FormikInput name="surname" label="Last Name" />
                    <FormikSelect
                        name="gender"
                        label="Gender"
                        data={genderInputs}
                    />
                    <FormikInput type="date" name="dob" label="Date Of Birth" />
                    <FormikSelect
                        name="education"
                        label="Education"
                        data={educationInputs}
                    />
                    <FormikSelect
                        name="baptised"
                        label="Baptised"
                        data={optionInputs}
                    />
                    <FormikSelect
                        name="confirmed"
                        label="Confirmed"
                        data={optionInputs}
                    />
                    <FormikSelect
                        name="disability"
                        label="Disability"
                        data={optionInputs}
                    />
                    <FormikInput name="occupation" label="Dream Occupation" />
                    <div className="d-flex align-items-center justify-content-between">
                        <FormikButton loading={isLoading} variant="contained">
                            Add Child
                        </FormikButton>
                    </div>
                </Form>
            </Grid>
        </Screen>
    );
}
